export default __webpack_public_path__ + "static/media/kyc-selfie-illustration-bad-de.78b69206.svg";